<app-contract-table-mt [widgetView]="true"></app-contract-table-mt>
